"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSortDescriptor = useSortDescriptor;
var react_1 = require("react");
/**
 * Tracks the table's active sort column and direction and exposes it in both the
 * shape HeroUI's Table expects and the shape the API expects.
 *
 * `onChange` runs after every sort change; pages use it to reset to page 1 so the
 * user sees the top of the newly ordered list.
 */
function useSortDescriptor(onChange) {
    var _a = (0, react_1.useState)(undefined), sortDescriptor = _a[0], setSortDescriptor = _a[1];
    var onSortChange = (0, react_1.useCallback)(function (descriptor) {
        setSortDescriptor(descriptor);
        onChange === null || onChange === void 0 ? void 0 : onChange();
    }, [onChange]);
    return (0, react_1.useMemo)(function () { return ({
        sortDescriptor: sortDescriptor,
        onSortChange: onSortChange,
        sortBy: sortDescriptor ? String(sortDescriptor.column) : undefined,
        sortDirection: sortDescriptor ? (sortDescriptor.direction === "descending" ? "desc" : "asc") : undefined,
    }); }, [sortDescriptor, onSortChange]);
}
